/**
 * Labels de presentación de enums de dominio.
 *
 * Mapas string→texto-usuario para enums que viven como literales en los
 * clientes API. Centralizados aquí para que las distintas vistas (Mis
 * Datos, wizard de onboarding, etc.) reusen el mismo texto sin duplicar.
 */
import type { ParentescoLiteral } from './api/residentes';
import type { EstadoRecurso, TipoRecurso, TipoTraccion } from './api/types';

export const PARENTESCO_LABEL: Record<ParentescoLiteral, string> = {
  titular: 'Titular',
  conyuge: 'Cónyuge',
  hijo: 'Hijo/Hija',
  padre: 'Padre',
  madre: 'Madre',
  hermano: 'Hermano/a',
  inquilino: 'Inquilino',
  personal_servicio: 'Personal de servicio',
  otro: 'Otro',
};

/** "Nombre (Parentesco)" para mostrar a quién pertenece un acceso/recurso.
 *  Vacío si no hay nombre. Reusado por Suspensiones y Reprogramación. */
export function nombreConParentesco(
  nombre: string | null,
  parentesco: string | null,
): string {
  if (!nombre) return '';
  const par = parentesco
    ? ` (${PARENTESCO_LABEL[parentesco as ParentescoLiteral] ?? parentesco})`
    : '';
  return `${nombre}${par}`;
}

export const TRACCION_LABEL: Record<TipoTraccion, string> = {
  combustion: 'Combustión',
  hibrido: 'Híbrido',
  electrico: 'Eléctrico',
};

export const RECURSO_TIPO_LABEL: Record<TipoRecurso, string> = {
  llavero: 'Llavero',
  control_remoto: 'Control remoto',
  otro: 'Otro',
};

/** Etiqueta del tipo de recurso, con fallback al valor crudo si no mapea
 * (ej. tipos que llegan como string genérico desde el backend). */
export function etiquetaTipoRecurso(tipo: string): string {
  return RECURSO_TIPO_LABEL[tipo as TipoRecurso] ?? tipo;
}

export const RECURSO_TIPO_ICONO: Record<TipoRecurso, string> = {
  llavero: '🔑',
  control_remoto: '📻',
  otro: '📦',
};

export const RECURSO_ESTADO_LABEL: Record<EstadoRecurso, string> = {
  entregado: 'Entregado',
  devuelto: 'Devuelto',
  perdido: 'Perdido',
  reemplazado: 'Reemplazado',
  reportado: 'Problema reportado',
  de_baja: 'Dado de baja',
};

export const RECURSO_ESTADO_COLOR: Record<EstadoRecurso, string> = {
  entregado: 'text-state-success',
  devuelto: 'text-text-muted',
  perdido: 'text-state-danger',
  reemplazado: 'text-text-muted',
  reportado: 'text-state-warning',
  de_baja: 'text-text-muted',
};
